import React from 'react';
import { observer } from 'mobx-react';
import VariantSelect from 'components/VariantSelect/VariantSelect';
import { CalculationMode } from 'common/interfaces';
import { RentModalsStore } from 'stores/workflowStores/finances/rentModalsStore';
import { PersonType } from 'enums';

interface Props {
  store: RentModalsStore;
  personType: PersonType;
}

const VariantSelection: React.FC<Props> = ({ store, personType }) => {
  return (
    <VariantSelect
      inside
      title="finQuestionnary_rentTypeSelect"
      variants={[
        {
          title: 'finQuestionnary_rentType_REQUIRED',
          text: 'finQuestionnary_rentType_REQUIRED_info',
          action: () => store.setFlow(CalculationMode.REQUIRED),
        },
        {
          title: 'finQuestionnary_rentType_MANUAL',
          text: 'finQuestionnary_rentType_MANUAL_info',
          action: () => store.setFlow(CalculationMode.MANUAL),
        },
        {
          title: 'finQuestionnary_rentType_CALCULATED',
          text: 'finQuestionnary_rentType_CALCULATED_info',
          action: () => store.setFlow(CalculationMode.CALCULATED),
        },
      ]}
    />
  );
};

export default observer(VariantSelection);
